import { GamesBreadcrumb } from "./index";
import { PlayGameLink } from "./index";

export default function FaceFinderGameInfo() {
  return (
    <div className="mx-auto p-4 bg-white dark:bg-slate-900/80 rounded-xl shadow">
      <GamesBreadcrumb game="Face Finder" />
      <h1 className="text-3xl font-bold mb-4 text-slate-900 dark:text-slate-100">Face Finder</h1>
      <img
        src="/thumbnails/FaceFinder.png"
        alt="Face Finder game screenshot"
        className="rounded-lg shadow mb-4 w-full max-w-md mx-auto bg-white dark:bg-slate-800"
      />
      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2 text-slate-900 dark:text-slate-100">About Face Finder</h2>
        <p className="text-gray-700 dark:text-gray-300">
          Face Finder is a social deduction game inspired by classic character-guessing games. Everyone is trying to identify the same hidden face by asking smart yes-or-no questions, narrowing down the grid, and making the correct guess before the other players do.
        </p>
      </section>
      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2 text-slate-900 dark:text-slate-100">How to Play</h2>
        <ul className="list-disc pl-6 space-y-1 text-gray-700 dark:text-gray-300">
          <li>Join a Face Finder room and wait for the shared target face to be selected.</li>
          <li>Take turns choosing deduction questions about hair, glasses, facial features, and other visible traits.</li>
          <li>Use each answer to rule out portraits that no longer fit the clues.</li>
          <li>When you are confident, make your guess and try to identify the hidden face before anyone else.</li>
        </ul>
      </section>
      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2 text-slate-900 dark:text-slate-100">Features</h2>
        <ul className="list-disc pl-6 space-y-1 text-gray-700 dark:text-gray-300">
          <li>Shared-target multiplayer deduction for groups of players.</li>
          <li>Portrait-based character grid with a wide range of visual traits.</li>
          <li>Quick yes-or-no prompts that keep each round moving.</li>
          <li>Easy to learn, spectator-friendly, and ideal for short rematches.</li>
        </ul>
      </section>
      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2 text-slate-900 dark:text-slate-100">Tips</h2>
        <ul className="list-disc pl-6 space-y-1 text-gray-700 dark:text-gray-300">
          <li>Start with broad questions that split the board into large groups.</li>
          <li>Watch what other players ask so you do not waste turns repeating clues.</li>
          <li>Keep track of eliminated faces mentally or on the screen before making a final guess.</li>
          <li>Guess only when the remaining candidates are tight enough that the risk is worth it.</li>
        </ul>
      </section>
      <section>
        <h2 className="text-xl font-semibold mb-2 text-slate-900 dark:text-slate-100">Play Face Finder</h2>
        <p className="text-gray-700 dark:text-gray-300">
          Jump into Face Finder with friends or open a public room and test your deduction skills online for free.
        </p>
        <PlayGameLink game="FaceFinder" gameTitle="Face Finder" />
      </section>
    </div>
  );
}